var R = require('ramda');
var m = require('mithril');
var d3 = require('d3');
var moment = require('moment');
var loaders = require('../../layout/components/loaders');
var Point = require('../../data/models/point');
var c3 = require('../../libs/chart');
var isReallyEmpty = R.either(R.isNil, R.isEmpty);
var isReallyNotEmpty = R.complement(isReallyEmpty);

var elementChart = {};

elementChart.oninit = function (vnode) {
  var ctrl = this;
  ctrl.element = vnode.attrs.element;
  try {
    ctrl.datasets = ctrl.element.out_Contains;
  } catch (e) {
    ctrl.datasets = false;
    return;
  }

  ctrl.columns = [];
  var columns = [];
  var hasBarGraph = false;

  ctrl.datasets.forEach(function (outContains) {
    var dataset = outContains.in;

    if (!Array.isArray(dataset.out_Column)) {
      return
    }

    dataset.out_Column.forEach(function (column) {
      if (column.chartType === 'bar') {
        hasBarGraph = true
      }
      ctrl.columns.push(column);
      columns.push(['x', column.name]);
    });
  })

  ctrl.chartData = {
    x: 'x',
    columns: columns
  };

  if (hasBarGraph) {
    ctrl.chartData.labels = {
      format: function (value) {
        return d3.format('.3s')(value);
      },
      size: 20
    }
  }

  ctrl.requestComplete = false;
  var startTime = moment().valueOf();
  Promise.all(ctrl.columns.map(function (column) {
    return loaders.requestWithLoader({
      url: '/api/v1/data/' + (column.in['@rid'].slice(1) || column.in['@rid']),
      method: 'GET',
      params: {
        start: startTime,
        span: ctrl.element.chartSpan || 8,
        resample: ctrl.element.chartResample || 'hours'
      },
      background: true,
      loader:'background'
    })
  }))
  .then(function (data) {
    data.map(function (timeseriesData, idx) {
      var ts = timeseriesData.data;
      if (ts.columns) {
        var rows = [];
        ts.values.forEach(function (row) {
          var colRecord = ctrl.columns[idx];
          if (row[1] == null) { return }
          rows.push([row[0], Point.readValue({unit: colRecord.in.unit, destUnit: colRecord.in.destUnit, displayUnit: colRecord.in.displayUnit, value: row[1]}, true)]);
        })
        rows.shift();
        rows.unshift(['x', ctrl.columns[idx].name + ' (' + Point.formatUnit(ctrl.columns[idx].in) + ')']);
        ctrl.options.data = {
          //x: 'x',
          type: ctrl.columns[idx].chartType || 'line',
          rows: rows
        };
        m.redraw();
        try {
          ctrl.chart.load(ctrl.options.data);
        } catch (e) {
          setTimeout(function () {
            ctrl.chart.load(ctrl.options.data);
          }, 500)
        }
      }
    })
  })
  .then(function () {
    ctrl.requestComplete = true;
  })

  ctrl.handleUpdate = function (data) {
    if (!ctrl.requestComplete) {return};
    if (data.rid == ctrl.point['@rid']) {
      if ((Date.now() - data.time) > 600000) {
        ctrl.chart.flow({
          rows: [
            ['x', ctrl.point.name],
            [data.time * 1000, Point.readValue({
              value: data.value,
              unit: ctrl.point.unit,
              destUnit: ctrl.point.destUnit,
              displayUnit: ctrl.point.displayUnit
            }, true)]
          ],
          length: 1
        });
      }
    };
  }

  ctrl.options = {
    //bindto: vnode.dom,
    data: ctrl.chartData,
    legend: {
      show: false,
    },
    color: {
      pattern: ['#2ca02c']
    },
    grid: {
      x: {
        show: false
      }
    },
    point: {
        show: false
    },
    tooltip: {
      show: false
    },
    axis: {
      y: {
        show:false,
        tick: {
          format: function (x) { return ''; }
        }
      },
      x: {
        show: false,
        tick: {
          format: function (x) { return ''; }
        }
      }
    },
    size: {
      height: 40,
      width: 80
    }
  }
};

elementChart.view = function() {
  var ctrl=this
  //console.log(ctrl.options)
  //var chart = (ctrl.columns ? m('div', {onupdate: function (vnode){elementChart.config(ctrl,vnode)},style: {float: "left"}}) : '');
  return m('div', /*{config: c3ParentContainerResizeFix(ctrl)},*/ [
    //m(heading, {label: ctrl.element.name, class: 'fw2 f3 pb1'}),
    //chart,
    m(c3,{
      options: ctrl.options,
      oncreate: function (vnode) {
        ctrl.chart = vnode.state.chart;
        vnode.attrs = ctrl.options
      }
    })
  ])
};


module.exports = elementChart;
